import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { Link } from "react-router-dom";
import "./Helpchat.css";
import Contact from "./Contact";

const ChefSupport = () => {
  const [expandBoost, setExpandBoost] = useState(false);
  const expandBoostfunc = () => {
    setExpandBoost(!expandBoost);
  };
  const [openCollapse, setOpenCollapse] = useState({
    open1: false,
    open2: false,
    open3: false,
    open4: false,
  });

  const handleCollapseToggle = (collapseKey) => {
    setOpenCollapse((prevState) => ({
      ...Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === collapseKey ? !prevState[key] : false;
        return acc;
      }, {}),
    }));
  };

  return (
    <div className="ps-2">
      <div>
        <p style={{ color: "blue", fontWeight: "500" }}>
          नमस्कार, हम यहां आपकी मदद के लिए हैं
        </p>
        <p style={{ color: "#ff5c09" }}>सुझाव :</p>
        <ul style={{ fontSize: "12px", lineHeight: "20px" }}>
          <li>
            अपनी प्रोफ़ाइल अपडेट करें: सुनिश्चित करें कि आपकी प्रोफ़ाइल पूरी तरह
            से अद्यतन है और उसमें सारी सही जानकारी मौजूद है। इसमें कंपनी के बारे
            में संक्षिप्त विवरण, आपके द्वारा ऑफ़र की जाने वाली भूमिकाएँ, लाभ और
            कार्य संस्कृति के बारे में जानकारी शामिल होनी चाहिए। अपनी प्रोफ़ाइल
            को 100% पूरा करने का प्रयास करें।
          </li>
          <li>
            नियमित रूप से आवेदनों की जांच करें: समय-समय पर आवेदनों की जांच करें
            ताकि आप यह सुनिश्चित कर सकें कि आप उपयुक्त उम्मीदवारों से चूक न
            जाएँ। जितनी जल्दी आप उनसे संपर्क करेंगे, उतनी ही अधिक संभावना है कि
            आप उन्हें किसी दूसरी कंपनी को खो देंगे।
          </li>
          <li>
            संबंधित नौकरियों के लिए ही आवेदन करें: केवल उन नौकरियों के लिए आवेदन
            करें जो आपकी कंपनी की जरूरतों और आपकी प्रोफ़ाइल से मेल खाती हों। ऐसा
            करने से आपका समय और प्रयास बचेगा और साथ ही आपको प्रासंगिक
            उम्मीदवारों से अधिक प्रतिक्रियाएँ प्राप्त होंगी।
          </li>
        </ul>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open1")}
          aria-controls="example-fade-text"
          aria-expanded={openCollapse.open1}
          className="help"
        >
          प्रोफ़ाइल
        </p>
        <Collapse in={openCollapse.open1}>
          <div id="example-fade-text">
            <p style={{ fontSize: "12px" }}>
              अपनी प्रोफ़ाइल को अपडेट करें और नियोक्ताओं द्वारा खोजे जाने और
              उनसे संपर्क किए जाने की अधिक संभावनाएं बढ़ाएं।
            </p>
            <Link
              to="/hin/cook/edit-cook-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              बेसिक प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/hin/cook/edit-chef-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              कुक प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/hin/cook/edit-cook-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              डीपी अपडेट करें
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open2")}
          aria-controls="example-fade-text1"
          aria-expanded={openCollapse.open2}
          className="mt-3 help"
        >
          जॉब्स
        </p>
        <Collapse in={openCollapse.open2}>
          <div id="example-fade-text1">
            <Link
              to="/hin/cook/jobs"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              नौकरियां खोजें
            </Link>
            <Link
              onClick={expandBoostfunc}
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              प्रोफ़ाइल बूस्ट करें
            </Link>
            {expandBoost && (
              <p>
                अधिक प्रतिक्रियाएं प्राप्त करने के लिए कुछ दिनों के लिए अपनी
                प्रोफ़ाइल को बढ़ाएं। इसके लिए मामूली शुल्क देना होगा।
                <Link to="/hin/cook/plans">Continue (Plans)</Link>
              </p>
            )}
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open3")}
          aria-controls="example-fade-text2"
          aria-expanded={openCollapse.open3}
          className="mt-3 help"
        >
          संपर्क सेटिंग्स
        </p>
        <Collapse in={openCollapse.open3}>
          <div id="example-fade-text2">
            <Link
              to="/hin/cook/profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              व्हाट्सऐप जोड़ें
            </Link>
            <Link
              to="/hin/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              मोबाइल नंबर बदलें
            </Link>
            <Link
              to="/hin/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              ईमेल बदलें
            </Link>
            <Link
              to="/hin/cook/settings"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              संपर्क गोपनीयता
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open4")}
          aria-controls="example-fade-text3"
          aria-expanded={openCollapse.open4}
          className="mt-3 help"
        >
          हमसे संपर्क करें
        </p>
        <Collapse in={openCollapse.open4}>
          <div id="example-fade-text3">
            <Contact />
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default ChefSupport;
